<template>
    <div>
        <div class="row text-center my-4">
            <div class="col-sm-3 font-weight-bold text-left">Vārds</div>
            <div class="col-sm-3 font-weight-bold text-left">Uzvārds</div>
            <div class="col-sm-6 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-12" style="max-height: 552px; overflow-x: hidden;">
            <UsersListItem v-for="user in sortedUsers" :user="user" :key="user._id"/>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import UsersListItem from '@/components/users/UsersListItem';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'users-list',
        components: {UsersListItem},
        props: {
            userRole: {
                type: String,
                default: 'user',
            }
        },
        computed: {
            ...mapGetters('company', {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            totalRows() {
                return this.currentCompany.users.filter(({role}) => role === this.userRole).length
            },
            sortedUsers() {
                let roleFiltered = this.currentCompany.users.filter(({role}) => role === this.userRole)
                let passedTests = roleFiltered.filter(({allTestsPassed}) => allTestsPassed)
                let notPassed = roleFiltered.filter(({allTestsPassed}) => !allTestsPassed)
                return [...notPassed, ...passedTests]
            }
        },
    }
</script>